import React, { useEffect, useState } from "react";
import { Tree } from "antd";
import type { TreeDataNode } from "antd";
import type { ITreeViewData } from "./types";

interface Props {
  data: ITreeViewData[];
}

const transformToAntTreeData = (
  data: ITreeViewData[],
  parentKey = ""
): TreeDataNode[] => {
  return data.map((item, index) => {
    const key = parentKey ? `${parentKey}-${index}` : `${index}`;

    return {
      key,
      title: (
        <div className="inline-block">
          <div className="flex flex-col justify-start items-start">
            <div>{item.message}</div>{" "}
            <div className="text-xs ml-auto">
              {item.time ? item.time : <></>}
            </div>
          </div>
        </div>
      ),
      icon: item.isFolder ? "📁" : "📄",
      children: item.children?.length
        ? transformToAntTreeData(item.children, key)
        : undefined,
    };
  });
};

const TreeView: React.FC<Props> = ({ data }) => {
  const [treeData, setTreeData] = useState<TreeDataNode[]>([]);

  useEffect(() => {
    const transformed = transformToAntTreeData(data);
    setTreeData(transformed);
  }, [data]);

  return <Tree treeData={treeData} defaultExpandAll showIcon />;
};

export default TreeView;
